var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5114 15.9076C19.528 16.5326 19.3614 17.1243 19.0614 17.6326C18.8947 17.9326 18.6697 18.2076 18.4197 18.4326C17.8447 18.966 17.0864 19.291 16.2447 19.316C15.028 19.341 13.953 18.716 13.3614 17.7576C13.0447 17.266 12.853 16.6743 12.8447 16.0493C12.8197 14.9993 13.2864 14.0493 14.0364 13.4243C14.603 12.9576 15.3197 12.666 16.103 12.6493C17.9447 12.6076 19.4697 14.066 19.5114 15.9076Z",
    stroke: "#EDB82E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8789 16.0084L15.7206 16.8083L17.4622 15.125",
    stroke: "#EDB82E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98633 7.18164L10.3447 11.44L17.653 7.20661",
    stroke: "#EDB82E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3438 18.99V11.4316",
    stroke: "#EDB82E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3526 8.62344V13.3401C18.3526 13.3818 18.3526 13.4151 18.3443 13.4568C17.7609 12.9484 17.0109 12.6485 16.1776 12.6485C15.3943 12.6485 14.6693 12.9235 14.0943 13.3818C13.3276 13.9901 12.8443 14.9318 12.8443 15.9818C12.8443 16.6068 13.0192 17.1985 13.3276 17.6985C13.4026 17.8318 13.4943 17.9568 13.5943 18.0735L12.0693 18.9151C11.1193 19.4485 9.56925 19.4485 8.61925 18.9151L4.16926 16.4485C3.16092 15.8901 2.33594 14.4901 2.33594 13.3401V8.62344C2.33594 7.47344 3.16092 6.07346 4.16926 5.51512L8.61925 3.04844C9.56925 2.5151 11.1193 2.5151 12.0693 3.04844L16.5193 5.51512C17.5276 6.07346 18.3526 7.47344 18.3526 8.62344Z",
    stroke: "#EDB82E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.de18d0d22411c7b0f334c4faa5f49472.svg";
export { ForwardRef as ReactComponent };